import { ComputedQuestionType } from './../../store/modules/exam-answer/types';

export const isSubjective = (questionType: ComputedQuestionType) => {
  return [
    ComputedQuestionType.Fill,
    ComputedQuestionType.MaterialRichText,
    ComputedQuestionType.RichText,
  ].includes(questionType);
};

export const isEqualMultipleChoice = (userAnswer: string[], rightAnswer: string[]) => {
  return (
    userAnswer.length === rightAnswer.length &&
    userAnswer.length === Array.from(new Set([...userAnswer, ...rightAnswer])).length
  );
};

export const getOptionIndex = (index: number, splitter?: string) => {
  splitter = splitter || '.';
  const indexList = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  return indexList[index] + splitter || '';
};
